import { render, staticRenderFns } from "./SpeedrunMilestoneCompare.vue?vue&type=template&id=7c3c5ff9&scoped=true"
import script from "./SpeedrunMilestoneCompare.vue?vue&type=script&lang=js"
export * from "./SpeedrunMilestoneCompare.vue?vue&type=script&lang=js"
import style0 from "./SpeedrunMilestoneCompare.vue?vue&type=style&index=0&id=7c3c5ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c5ff9",
  null
  
)

export default component.exports